<style scoped lang="scss">

</style>

<template>
    <div>
        <div class="uk-form" v-if="application">

            <fieldset data-uk-margin>
                <legend>Third Party to the landlord or property management company</legend>


                <p>
                    The Applicant and any co-applicants and residents 18 years and older (if any) named below
                    (individually and collectively, "Applicant"), authorize the Landlord/Property Management Company
                    and applicable utility and internet companies included in this application and the Third Parties
                    assisting the West Virginia Housing Development Fund in the review of the Mountaineer Rental
                    Assistance Program (MRAP) applications (Individually and collectively, "Third Party") to share,
                    release, discuss, and otherwise provide to and with each other public and non-public personal
                    information contained in or related to the lease, utilities, including internet, and/or the MRAP
                    application of the Applicant.
                </p>

            </fieldset>

            <div class="uk-container uk-margin-top" >
                <div class="uk-grid">
                    <div class="uk-panel uk-panel-box uk-width-1-1"> <span class="uk-panel-title"><i class="uk-icon-exclamation-circle uk-icon-large theme-primary-color"></i> <u>Before signing this Third-Party Authorization, beware of foreclosure scams!</u></span>
                        <div class="uk-panel-body">
                            <ul>
                                <li>It is expected that an {{ application.program.program_name }} Servicer/Property Manager Liaison will work directly with your lender/mortgage servicer/property manager.</li>
                                <li>Beware of anyone who asks you to pay a fee in exchange for a counseling service or modification of a delinquent loan or lease.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="uk-margin-large-bottom">
                <fieldset>
                    <div class="uk-container uk-margin-top" >
                        <div class="uk-grid" v-if="application.household">
                            <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2" v-for="member in application.household.members">
                                <div v-if="member.age >= 18">
                                    <validated-section :errors="errors" :field="'signature_'+member.id">
                                        <signature-box @updated="onSignatureUpdated"
                                                       :user-key="member.id"
                                                       :is-signed="signatureData[member.id] && signatureData[member.id].third_party_authorization_signed_at !== null"
                                                       :completed="signatureData[member.id] && signatureData[member.id].completed"
                                                       :name="member.first_name + ' ' + member.last_name"
                                                       :color="programSettings['primary-program-color']"
                                        ></signature-box>
                                    </validated-section>

                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import SignatureBox from "../../../../../components/AppWizard/SignatureBox";
    import ValidatedSection from "../../../../../components/Common/ValidatedSection";

    export default {
        name: "ThirdPartyAuthorization",
        components: {ValidatedSection, SignatureBox},
        data() {
            return {
                signatureData: {},
                errors: {},
            }
        },
        computed: {
            ...mapState('Application', {
                application: state => state.application,
            }),
            ...mapGetters('Application', [ 'programSettings' ])
        },
        watch: {
            application(newValue) {
                if(newValue.household) {
                    this.initData();
                }
            }
        },
        mounted() {
            if(this.application) this.initData();
        },
        methods: {
            initData() {
                _.each(this.application.household.members, member => {
                    if(member.age >= 18) {
                        const signatureFiltered = member.signatures.find(item => item.key === `app-third-party`)
                        if(signatureFiltered) {
                            this.$set(this.signatureData, member.id, {
                                third_party_authorization_signed_at: member.third_party_authorization_signed_at,
                                completed: true
                            })
                        }
                    }
                })
            },
            onSignatureUpdated($event) {
                if(!this.signatureData[$event.key]) {
                    this.$set(this.signatureData, $event.key, {});
                }
                this.$set(this.signatureData[$event.key], 'third_party_authorization_signed_at', $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null);
            },
            async validateStep() {
                this.errors = {};
                // Local Validation
                for(var i in this.application.household.members) {
                    let member = this.application.household.members[i];
                    if(member.age >= 18) {
                        if(!this.signatureData[member.id]) {
                            this.errors['signature_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must sign this form as their name appears above.'],
                            };
                        }else if(this.signatureData[member.id] && this.signatureData[member.id].third_party_authorization_signed_at == null) {
                            this.errors['signature_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must sign this form as their name appears above.'],
                            };
                        }
                    }
                }

                let errorCount = _.size(this.errors);

                if(errorCount > 0) return false;

                // Server Side Validation
                try {
                    let response = await this.save();
                    return true;
                }catch(err) {
                    console.error(err);
                }
            },
            save() {
                let data = {
                    signatures: this.signatureData,
                }
                return axios.put(`/api/hope/applications/${this.application.id}/step-7`, data);
            }
        }
    }
</script>
